export default "__VITE_ASSET__DcAtlC3w__"